module.exports = __webpack_public_path__ + "static/mountainBG-e11334b190b6de278d5ecbf44e0c3f9a.png";